import PostAnalyticsDialog from './PostAnalyticsDialog';

export default PostAnalyticsDialog;